import "./intro.css";

import { FaAward } from "react-icons/fa";
import React from "react";
import { VscFolderLibrary } from "react-icons/vsc";

const Intro = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src="https://avatars.githubusercontent.com/u/143329360?s=400&u=d588024a638ccc70e68299f67cfe25eb5eaf752c&v=4" alt="Suraj" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>2 year</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>20+ Completed Projects</small>
            </article>
          </div>
          <p>
            Motivated Full Stack Web Developer with solid experience in building web applications using JavaScript, React.js,
            Node.js, Express.js, and MongoDB. Completed hands-on projects demonstrating proficiency in front-end and back-end
            technologies, with a focus on user-friendly interfaces, API development, and real-time functionalities. Ready to transition
            project experience into a professional development role.
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default Intro;
